import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Layout from "../Pages/Layout/Layout";
import Services from "../Pages/Services/Services";
import Templates from "../Pages/Templates/Templates";
import Home from "../Pages/Home/Home";
import About from "../Pages/About/About";
import Contact from "../Pages/Contact/Contact";
import ScrollToTop from "../components/ScrollToTop";
import WebsiteTemplates from "../components/WebsiteTemplates/WebsiteTemplates";
import Invitations from "../components/Invitations/Invitations";
import Events from "../components/Invitations/Events/Events";
import NotFound from "../components/NotFound/NotFound";

const AppRouter = () => {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/templates" element={<Templates />}>
            <Route index element={<Navigate to="/templates/websites" replace />} />
            <Route path="websites" element={<WebsiteTemplates />} />
            <Route path="invitations" element={<Invitations />}>
              <Route index element={<Navigate to="wedding" replace />} />
              <Route path="wedding" element={<Events />} />
              <Route path="birthday" element={<Events />} />
              <Route path="christening" element={<Events />} />
              <Route path="engagement" element={<Events />} />
              <Route path="others" element={<Events />} />
            </Route>
          </Route>
          <Route path="/contact" element={<Contact />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
};

export default AppRouter;
